import { ListKeyManagerOption } from '@angular/cdk/a11y';
import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

import { CarouselSlideItem } from './carousel-slide';

@Component({
  standalone: false,
  selector: 'app-carousel-slide-item',
  templateUrl: './carousel-slide-item.component.html',
  styleUrls: ['./carousel-slide-item.component.scss']
})
export class CarouselSlideItemComponent implements ListKeyManagerOption, CarouselSlideItem, OnInit {
  @Input() public image: SafeStyle;
  @Input() public overlayColor = '#00000040';
  @Input() public hideOverlay = false;
  @Input() public disabled = false;
  @Input() public imageSize: CarouselSlideItem['imageSize']  = 'cover';

  @ViewChild(TemplateRef) public templateRef: TemplateRef<any>;
    
  constructor(public sanitizer: DomSanitizer) { }

  ngOnInit() {
    if (this.image) {
      this.image = this.sanitizer.bypassSecurityTrustStyle(`url("${this.image}")`);
    }
  }

}
